import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import PropTypes from "prop-types";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { connect } from "react-redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import Clock from "../../../../../Assets/Icons/Clock-time/clock-time-16px.svg";
import employee from "../../../../../Assets/Icons/Employees/employees-16px.svg";
import Search from "../../../../../Assets/Icons/Search/search-16px.svg";

import LabelIcon from "../../../../../Component/Labels/LabelIcon";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  drawerPaper: {
    width: "30%",
  },
});

class AttendanceDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      open: false,
      firstName: "",
      lastName: "",
      emailId: "",
      DrawerOpen: false,
      right: false,
      overtimes: [],
      punctuality: [],
      address: [],
      absents: [],
      labels: ["Present", "On leave", "Absent"],
    };
  }

  componentDidMount() {
    this.getOverTime();
    this.getPunctuality();
    this.getMostAbsents();
    this.getEmployeeHeadCount();
  }

  getEmployeeHeadCount() {
    instance
      .post("trackdashboard/employeeattendancecount")
      .then((result) => {
        const all = result.data.result[0].all && result.data.result[0].all[0];
        const address = [
          {
            presentcount: all.presentcount,
            onleavecount: all.onleavecount,
            absentcount: all.absentcount,
            locationname: "All",
          },
          ...(result.data.result[0].officeaddress &&
            result.data.result[0].officeaddress),
          {
            presentcount: all.presentcount,
            onleavecount: all.onleavecount,
            absentcount: all.absentcount,
            locationname: "All",
          },
        ];
        this.setState({
          address,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getPunctuality() {
    instance
      .post("trackdashboard/employeepunctuality")
      .then((result) => {
        const punctuality = [
          ...(result.data.result[0].latecoming &&
            result.data.result[0].latecoming.map((data) => ({
              ...data,
              latecoming: true,
            }))),
          ...(result.data.result[0].earlygoing &&
            result.data.result[0].earlygoing.map((data) => ({
              ...data,
              latecoming: false,
            }))),
        ];
        this.setState({
          punctuality,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getOverTime() {
    instance
      .post("trackdashboard/overtimeemployee")
      .then((result) => {
        this.setState({
          overtimes: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getMostAbsents() {
    instance
      .post("trackdashboard/mostabsentemployee")
      .then((result) => {
        this.setState({
          absents: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    return (
      <div className="content-outer-wrapper-with-tab">
                <Helmet>
          <title>{headersList.Attendance.Dashboard.header}</title>
        </Helmet>
        <Grid container>
          <Grid
            item
            xs={12}
            md={12}
            sm={12}
            style={{ padding: "0px 12px 0px 24px" }}
          >
            <div className="margin-bottom-24">
              <LabelIcon label="Employees in office" img={employee} />
              <Paper
                style={{
                  height: 200,
                  position: "relative",
                }}
              >
                <div style={{ padding: "8px 16px" }}>
                  <Grid container>
                    <Grid item xs={12} md={12} sm={12}>
                      <Grid
                        container
                        style={{ overflowX: "auto", flexWrap: "nowrap" }}
                      >
                        {this.state.address.map((address, index) => {
                          const count = [
                            address.presentcount,
                            address.onleavecount,
                            address.absentcount,
                          ];
                          return (
                            <Grid
                              item
                              xs={12}
                              md={
                                index == this.state.address.length - 1 ? 3 : 2
                              }
                              sm={12}
                              style={{ flex: "0 0 auto" }}
                            >
                              <div
                                className={
                                  index == this.state.address.length - 1
                                    ? "doughnut-chart-attendance-data"
                                    : "doughnut-chart-attendance"
                                }
                              >
                                <div
                                  className={
                                    index == this.state.address.length - 1
                                      ? "hide-chart"
                                      : ""
                                  }
                                ></div>
                                <Doughnut
                                  data={{
                                    labels: this.state.labels,
                                    datasets: [
                                      {
                                        label: address.locationname,
                                        data: count,
                                        backgroundColor: [
                                          "#f7b596",
                                          "#b596f7",
                                          "#f7dc96",
                                          "#96acf7",
                                          "#96f7df",
                                          "#f7dc96",
                                          "#d0f796",
                                          "#e0f7fa",
                                          "#eceff1",
                                          "#efebe9",
                                          "#d7ccc8",
                                          "#cfd8dc",
                                          "#e3f2fd",
                                          "#fff9c4",
                                          "#b2dfdb",
                                          "#c8e6c9",
                                          "#e0e0e0",
                                          "#ffe0b2",
                                          "#f3e5f5",
                                        ],
                                      },
                                    ],
                                  }}
                                  width="150px"
                                  height="100px"
                                  options={{
                                    rotation: 100,
                                    animation: {
                                      animateRotate: true,
                                    },
                                    tooltips: {
                                      footerFontSize: 16,
                                      titleFontSize: 16,
                                      bodyFontSize: 16,
                                    },
                                    title: {
                                      display: true,
                                      text:
                                        index != this.state.address.length - 1
                                          ? address.locationname
                                          : "",
                                      position: "top",
                                      fontSize: 16,
                                    },
                                    legend: {
                                      display:
                                        index == this.state.address.length - 1
                                          ? true
                                          : false,
                                      position: "left",
                                      fullWidth: false,
                                      labels: {
                                        fontSize: 16,
                                        fontFamily: "Muli",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
            </div>
          </Grid>
        </Grid>
        <Grid container>
          {this.state.punctuality.length > 0 && (
            <Grid
              item
              xs={12}
              md={4}
              sm={12}
              style={{ padding: "0px 12px 0px 24px" }}
            >
              <div className="margin-bottom-24">
                <LabelIcon label="Today’s punctuality problems" img={Clock} />
                <Paper
                  className="padding16 thin-scroll"
                  style={{
                    height: 200,
                    overflowY: "auto",
                    position: "relative",
                  }}
                >
                  {this.state.punctuality.length > 0 ? (
                    this.state.punctuality.map((data) => (
                      <div style={{ padding: "8px 16px" }}>
                        <Grid
                          container
                          style={{
                            borderBottom: "1px solid #edf5fd",
                            paddingBottom: 4,
                          }}
                        >
                          <Grid item xs={12} md={1} sm={12}>
                            <p className="t-12 margin-top-2">
                              {data.latecoming && "⏰"}
                              {!data.latecoming && "🏃‍♂️"}
                            </p>
                          </Grid>
                          <Grid item xs={12} md={7} sm={12}>
                            <p className="small-dark-secondary">
                              {data.fullname}
                            </p>
                            <p className="extra-small-dark-disabled">
                              {data.designationname}
                            </p>
                          </Grid>
                          <Grid item xs={12} md={4} sm={12}>
                            <p className="small-dark-secondary text-align-right">
                              {data.latecoming && "Late"}
                              {!data.latecoming && "Left early"}
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    ))
                  ) : (
                    <div className="text-align-center margin-top-30">
                      No records found
                    </div>
                  )}
                </Paper>
              </div>
            </Grid>
          )}
          {this.state.overtimes.length > 0 && (
            <Grid
              item
              xs={12}
              md={4}
              sm={12}
              style={{ padding: "0px 12px 0px 12px" }}
            >
              <div className="margin-bottom-24">
                <LabelIcon label="Overtimers this week" img={Clock} />
                <Paper
                  className="padding16 thin-scroll"
                  style={{
                    overflowY: "auto",
                    height: 200,
                  }}
                >
                  {this.state.overtimes.length > 0 ? (
                    this.state.overtimes.map((overtime) => (
                      <div style={{ padding: "8px 16px" }}>
                        <Grid
                          container
                          style={{
                            borderBottom: "1px solid #edf5fd",
                            paddingBottom: 4,
                          }}
                        >
                          <Grid item xs={12} md={1} sm={12}>
                            <p className="t-12 margin-top-2">🔥</p>
                          </Grid>
                          <Grid item xs={12} md={11} sm={12}>
                            <p className="small-dark-secondary">
                              {overtime.fullname}
                            </p>
                            <p className="extra-small-dark-disabled">
                              {overtime.designationname}
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    ))
                  ) : (
                    <div className="text-align-center margin-top-30">
                      No records found
                    </div>
                  )}
                </Paper>
              </div>
            </Grid>
          )}
          {this.state.absents.length > 0 && (
            <Grid
              item
              xs={12}
              md={4}
              sm={12}
              style={{ padding: "0px 12px 0px 12px" }}
            >
              <div className="margin-bottom-24">
                <LabelIcon label="Most absent last week" img={Search} />
                <Paper
                  className="padding16 thin-scroll"
                  style={{
                    overflowY: "auto",
                    height: 200,
                  }}
                >
                  {this.state.absents.length > 0 ? (
                    this.state.absents.map((emp) => (
                      <div style={{ padding: "8px 16px" }}>
                        <Grid
                          container
                          style={{
                            borderBottom: "1px solid #edf5fd",
                            paddingBottom: 4,
                          }}
                        >
                          <Grid item xs={12} md={1} sm={12}>
                            <p className="t-12 margin-top-2">🔍</p>
                          </Grid>
                          <Grid item xs={12} md={7} sm={12}>
                            <p className="small-dark-secondary">
                              {emp.fullname}
                            </p>
                            <p className="extra-small-dark-disabled">
                              {emp.designationname}
                            </p>
                          </Grid>
                          <Grid item xs={12} md={4} sm={12}>
                            <p className="small-dark-secondary text-align-right">
                              {emp.totalabsentcount} Absences
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    ))
                  ) : (
                    <div className="text-align-center margin-top-30">
                      No records found
                    </div>
                  )}
                </Paper>
              </div>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

AttendanceDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(AttendanceDashboard)),
);
